import { render, staticRenderFns } from "./TraveldocList.vue?vue&type=template&id=dbf9f4c2&"
import script from "./TraveldocList.vue?vue&type=script&lang=js&"
export * from "./TraveldocList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports